import { CiudadAsesor } from './ciudad-asesor.class';
import { Agente } from './agente.class';
import * as msg from '../../../assets/msg/message.json';

export class Asesor extends Agente {


    ciudades: CiudadAsesor[];
    constructor() {
        super();
        this.ciudades = [];
    }

    public getRestriccionSeleccionAgente() {
        return (<any>msg).msgHome.seleccioneCiudad;
    }

}




// WEBPACK FOOTER //
// ./src/app/models/agente/asesor.class.ts